import { render, staticRenderFns } from "./SidebarChicksGlobal.vue?vue&type=template&id=6428b6f8"
import script from "./SidebarChicksGlobal.vue?vue&type=script&lang=js"
export * from "./SidebarChicksGlobal.vue?vue&type=script&lang=js"
import style0 from "./SidebarChicksGlobal.vue?vue&type=style&index=0&id=6428b6f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports